const genericMediaTypes = new Set([
  '',
  'application/octet-stream',
  'binary/octet-stream',
  'application/binary',
]);

const mediaTypeByExtension: Record<string, string> = {
  pdf: 'application/pdf',
  txt: 'text/plain',
  log: 'text/plain',
  md: 'text/plain',
  csv: 'text/csv',
  xml: 'application/xml',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  tif: 'image/tiff',
  tiff: 'image/tiff',
};

const normaliseMediaType = (value?: string | null) =>
  String(value ?? '').split(';', 1)[0]!.trim().toLowerCase();

export function effectivePreviewMediaType(
  fileName: string,
  storedMediaType?: string | null,
  responseMediaType?: string | null,
) {
  const response = normaliseMediaType(responseMediaType);
  if (!genericMediaTypes.has(response)) return response;

  const declared = normaliseMediaType(storedMediaType);
  if (!genericMediaTypes.has(declared)) return declared;

  const extension = fileName.toLowerCase().split('.').pop() ?? '';
  return mediaTypeByExtension[extension] ?? 'application/octet-stream';
}

export function canPreviewDocument(fileName: string, storedMediaType?: string | null) {
  const type = effectivePreviewMediaType(fileName, storedMediaType);
  return (
    type === 'application/pdf' ||
    type === 'text/plain' ||
    type === 'text/csv' ||
    type === 'application/xml' ||
    ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/tiff'].includes(type)
  );
}

export function isImageDocumentPreview(
  fileName: string,
  storedMediaType?: string | null,
  responseMediaType?: string | null,
) {
  return effectivePreviewMediaType(fileName, storedMediaType, responseMediaType).startsWith('image/');
}

export function typedPreviewBlob(
  blob: Blob,
  fileName: string,
  storedMediaType?: string | null,
  responseMediaType?: string | null,
) {
  const type = effectivePreviewMediaType(fileName, storedMediaType, responseMediaType ?? blob.type);
  return blob.type === type ? blob : new Blob([blob], { type });
}
